/* eslint-disable camelcase */
export enum DocumentsTypes {
  GET_DOCUMENTS_REQUEST = '@panel/GET_DOCUMENTS_REQUEST',
  GET_DOCUMENTS_SUCCESS = '@panel/GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_FAILURE = '@panel/GET_DOCUMENTS_FAILURE',
  SERVICE_SUBSCRIPTION_STATUS_REQUEST = '@documents/SERVICE_SUBSCRIPTION_STATUS_REQUEST',
  SERVICE_SUBSCRIPTION_STATUS_SUCCESS = '@documents/SERVICE_SUBSCRIPTION_STATUS_SUCCESS',
  SERVICE_SUBSCRIPTION_STATUS_FAILURE = '@documents/SERVICE_SUBSCRIPTION_STATUS_FAILURE',
  DELETE_DOCUMENT_REQUEST = '@documents/DELETE_DOCUMENT_REQUEST',
  DELETE_DOCUMENT_SUCCESS = '@documents/DELETE_DOCUMENT_SUCCESS',
  DELETE_DOCUMENT_FAILURE = '@documents/DELETE_DOCUMENT_FAILURE',
  SAVE_DOC_DATABASE_REQUEST = '@documents/SAVE_DOC_DATABASE_REQUEST',
  SAVE_DOC_DATABASE_SUCCESS = '@documents/SAVE_DOC_DATABASE_SUCCESS',
  SAVE_DOC_DATABASE_FAILURE = '@documents/SAVE_DOC_DATABASE_FAILURE',
  FILTER_DOCUMENTS_REQUEST = '@documents/FILTER_DOCUMENTS_REQUEST',
  FILTER_DOCUMENTS_SUCCESS = '@documents/FILTER_DOCUMENTS_SUCCESS',
  FILTER_DOCUMENTS_FAILURE = '@documents/FILTER_DOCUMENTS_FAILURE',
  UPDATE_DOCUMENT_REQUEST = '@documents/UPDATE_DOCUMENT_REQUEST',
  UPDATE_DOCUMENT_SUCCESS = '@documents/UPDATE_DOCUMENT_SUCCESS',
  UPDATE_DOCUMENT_FAILURE = '@documents/UPDATE_DOCUMENT_FAILURE',
  AUTHENTICATE_DOCUMENT_REQUEST = '@documents/AUTHENTICATE_DOCUMENT_REQUEST',
  AUTHENTICATE_DOCUMENT_SUCCESS = '@documents/AUTHENTICATE_DOCUMENT_SUCCESS',
  AUTHENTICATE_DOCUMENT_FAILURE = '@documents/AUTHENTICATE_DOCUMENT_FAILURE',
  SET_AUTHENTICATE_DOCUMENT_INITIAL_STATE = '@documents/SET_AUTHENTICATE_DOCUMENT_INITIAL_STATE',
  ALERT_TIME = '@documents/ALERT_TIME',
  LIST_DOCUMENT = '@documents/LIST_DOCUMENT',
  CURRENT_COMPANY = '@documents/CURRENT_COMPANY',
}

export interface DocumentsGroup {
  value: string | number;
  label: string;
}
export interface DocumentData {
  id: number | string;
  authenticatedId: number;
  description: string;
  digitalAuthentication: string;
  authenticationStatus: string;
  document_group: string;
  document_group_id: number;
  document_type_id: number;
  expirationDate: string;
  fileUrl: string;
  is_aws: boolean;
  is_pdf: boolean;
  name: string;
  status: number;
  statusLabel: string;
  available: boolean;
  document_type_description: string;
  statusDetails: number;
  default: {
    id: number;
    state: string;
    documentName: string;
  };
}

export interface MonitoredCompaniesTypes {
  id: number;
  client_id: number;
  company_name: string;
  monitored_company: string;
}

export interface CompanyTypes {
  id: number;
  companyName: string;
  value: string;
}

export interface DocumentsType {
  message: string;
  message_view: boolean;
  class_success_or_failure: string;
  company_name: string;
  monitored_company: string;
  monitored_companies: Array<MonitoredCompaniesTypes>;
  current_cnpj: string;
  company: Array<any>;
}

export interface RequestState {
  get_documents: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  filter_documents: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  service_subscription_status: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  delete_document: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  save_doc_database: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  update_document: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  authenticate_document: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  download_authenticated_document: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface DocumentsState {
  readonly documents: Array<DocumentData>;
  readonly documents_list: DocumentsType;
  readonly request: RequestState;
}
